(() => {
  const story = document.querySelector('[data-ciao-story]');
  if (!story) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Fade pieces in as they scroll into view
  const revealables = story.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !reduceMotion) {
    const revealer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          revealer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );
    revealables.forEach((el) => revealer.observe(el));
  } else {
    revealables.forEach((el) => el.classList.add('is-in'));
  }

  // Timeline: fill the spine and track the active chapter
  const timeline = story.querySelector('[data-timeline]');
  const chapters = [...story.querySelectorAll('[data-chapter]')];
  const indexLinks = [...story.querySelectorAll('[data-index-link]')];

  if (timeline && chapters.length) {
    let ticking = false;

    const update = () => {
      ticking = false;
      const focusLine = window.innerHeight * 0.55;
      const rect = timeline.getBoundingClientRect();
      const progress = Math.min(1, Math.max(0, (focusLine - rect.top) / rect.height));
      timeline.style.setProperty('--progress', progress.toFixed(4));

      let active = 0;
      chapters.forEach((chapter, i) => {
        if (chapter.getBoundingClientRect().top < focusLine) active = i + 1;
      });

      chapters.forEach((chapter, i) => chapter.classList.toggle('is-active', i + 1 === active));
      indexLinks.forEach((link) => {
        if (Number(link.dataset.indexLink) === active) {
          link.setAttribute('aria-current', 'step');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  }

  // Smooth jumps from the chapter index and the "begin" link
  story.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', link.getAttribute('href'));
    });
  });

  // Inspiration cards turn over on click / Enter / Space
  story.querySelectorAll('[data-flip]').forEach((card) => {
    card.addEventListener('click', () => {
      const flipped = card.getAttribute('aria-pressed') === 'true';
      card.setAttribute('aria-pressed', String(!flipped));
    });
  });
})();
